import React from 'react';
import cx from 'classnames';
import ReactDOM from 'react-dom';

import './app-portal.scss';

interface AppPortalProps {
  className?: string;
  children?: React.ReactNode;
  usePortal?: boolean;
}

interface AppPortalState {
  didMount: boolean;
}

export class AppPortal extends React.Component<AppPortalProps, AppPortalState> {
  static defaultProps = {
    className: '',
    usePortal: true
  };

  el: HTMLDivElement | undefined;

  constructor(props: AppPortalProps) {
    super(props);

    this.state = {
      didMount: false
    };
  }

  componentDidMount = () => {
    this.setState({didMount: true});
    const rootElement = global.document.getElementById('portal');
    if (!rootElement) {
      throw new Error('AppPortal needs a #portal element in the document');
    }
    this.el = global.document.createElement('div');
    rootElement.appendChild(this.el);
  };

  componentWillUnmount = () => {
    this.el?.remove();
  };

  stopPropagation = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };

  onKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.stopPropagation();
    }
  };

  render() {
    const {children, className, usePortal} = this.props;
    if (!this.el) {
      return null;
    }

    if (!usePortal) {
      return (
        <div
          className={cx('app-portal', className)}
          onKeyPress={this.onKeyPress}
          onClick={this.stopPropagation}
        >
          {children}
        </div>
      );
    }
    return ReactDOM.createPortal(
      <div onKeyPress={this.onKeyPress} onClick={this.stopPropagation} className={className}>
        {children}
      </div>,
      this.el
    );
  }
}
